import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import styles from 'modules/Profile/components/FamilyAccess/FamilyAccess.module.scss';
import Button, { BUTTON_COLORS } from 'components/Button';

const GrantAccess = ({ onClose, onSubmit }) => {
  const [isLoading, setLoading] = useState(false);
  const onGrantSuccess = useCallback(async () => {
    setLoading(true);
    const { error } = await onSubmit();
    if (error) {
      setLoading(false);
    }
  }, [onSubmit]);
  return (
    <div className={styles.grantAccess}>
      <h2>Запрос на получение доступа</h2>
      <div className={styles.text}>
        Разрешаю законному представителю (родителю) доступ к информации из моего Личного кабинета
        налогоплательщика
      </div>
      <div className={styles.actions}>
        <Button
          extraClassName={styles.button}
          isDisabled={isLoading}
          color={BUTTON_COLORS.WHITE_BLUE}
          hasWrapper={false}
          onClick={onClose}
        >
          Отклонить
        </Button>
        <Button
          extraClassName={styles.button}
          isDisabled={isLoading}
          color={BUTTON_COLORS.ORANGE}
          hasWrapper={false}
          onClick={onGrantSuccess}
        >
          Подтвердить
        </Button>
      </div>
    </div>
  );
};

GrantAccess.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default GrantAccess;
